import { Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';
import { FC } from 'react';

const Text: FC<TextProps> = ({ children, ...linkProps }) => {
  return <Typography.Text {...linkProps}>{children}</Typography.Text>;
};

export default Text;
